import request from '@/utils/request';

export function getWholesaleOrderList(data) {
  return request({
    url: `/sc-basic-merchant-backend/wholesale/order/page`,
    method: "post",
    data,
  });
}

export function getWholesaleOrderDetail(params) {
  return request({
    url: `/sc-basic-merchant-backend/wholesale/order/detail`,
    params,
  });
}

export function mergeWholesaleOrder(data) {
  return request({
    url: `/sc-basic-merchant-backend/wholesale/order/merge`,
    method: "post",
    data,
  });
}

export function removeWholesaleOrder(data) {
  return request({
    url: `/sc-basic-merchant-backend/wholesale/order/remove`,
    method: "post",
    data,
  });
}

export function getWholesaleOrderType(params) {
  return request({
    url: `/sc-basic-merchant-backend/wholesale/order/type/enum`,
    params,
  });
}

